//@ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { Button2 as Button, Link, Text } from 'platform-components';
import { InjectedProps as WithRouterPathProps, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { isLessonCompleted } from 'common.components/lesson/utils';
import { getCourseByClassAndId } from 'store/courses/selectors';
import { getTeamIdFromPath } from 'utils/path';

import './lesson-view__sandbox-stub.scss';

interface StoreProps {
    teamId: number | null;
    cLessonId: number | null;
    lessonStatus: LESSON_STATUS | null;
    subject: SUBJECTS_SLUGS | undefined;
}

interface HOCProps extends WithRouterPathProps {}

interface Props extends StoreProps, HOCProps {}

interface Context {
    basePath: string;
    prefix: string;
    staticUrls: {
        labSubjectLessonsActive: string;
        labSubjectLessonsComplete: string;
    };
}

const LessonViewSandboxStub = (props: Props, context: Context) => {
    const { teamId, cLessonId, getRouterPath, lessonStatus, subject } = props;
    const {
        basePath,
        prefix,
        staticUrls: { labSubjectLessonsActive, labSubjectLessonsComplete },
    } = context;

    if (!cLessonId || !lessonStatus) {
        return null;
    }

    const path = isLessonCompleted(lessonStatus) ? labSubjectLessonsComplete : labSubjectLessonsActive;

    const link =
        teamId && subject
            ? `${basePath}${prefix}${getRouterPath(path, { classId: teamId, subject })}?lessonId=${cLessonId}`
            : null;

    return (
        <div className="lesson-view__sandbox-stub">
            <div className="lesson-view__sandbox-stub-content">
                <Text id="lessonView.sandboxStub.description" type={Text.TYPE.MARKDOWN} />
                {link && (
                    <Link to={link}>
                        <Button mix="lesson-view__sandbox-stub-button" theme={Button.THEMES.ACTION}>
                            <Text id="lessonView.sandboxStub.button" weight={Text.WEIGHT.M} />
                        </Button>
                    </Link>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const courseId = lessonSelectors.getLessonOrCurrentYearCourseId(storeState);
    const teamId = getTeamIdFromPath();
    const course = getCourseByClassAndId(storeState, { classId: teamId, courseId });

    return {
        teamId,
        cLessonId: lessonSelectors.getCLessonId(storeState),
        lessonStatus: lessonSelectors.getLessonStatus(storeState),
        subject: course?.subject,
    };
};

LessonViewSandboxStub.contextTypes = {
    basePath: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    staticUrls: PropTypes.object.isRequired,
};

export default withRouterPath(connect(mapStateToProps)(LessonViewSandboxStub));
